<h3 [class]="'message-subheader level-' + (content.level || 2)">{{ content.text }}</h3>

